export default __webpack_public_path__ + "static/media/01714D42-CB2D-460B-AB91-23CCBE7DD9FC_1_105_c.39cada85.jpeg";